

export class DashboardExpenseStatusSummary {
    amount: number;
    status: number;
    count: number;
    claimants: number;
}
